import { HorizontalScroll } from "@components";
import { LanguageContext } from "@contexts";
import { HappeningThumbnail } from "@features/article/HappeningThumbnail/HappeningThumbnail";
import { sortArticles } from "@lib";
import { LanguageContextType } from "@types";
import { Button } from "@ui/buttons";
import { Link, graphql, useStaticQuery } from "gatsby";
import * as React from "react";
import { useContext } from "react";
import { WHATS_NEW_QUERY } from "src/pages/hva-skjer";

interface IProps {
  currentArticleId: string;
}

export const RelatedArticles: React.FC<IProps> = ({ currentArticleId }) => {
  const result = useStaticQuery(WHATS_NEW_QUERY);
  const allSanityNews = result.allSanityNews.edges;

  const { localize } = useContext<LanguageContextType>(LanguageContext);

  const articles = sortArticles([...allSanityNews])
    .slice(0, 6)
    .filter(({ node }) => node._id !== currentArticleId);

  return (
    <div style={{ textAlign: "center" }}>
      <HorizontalScroll>
        {articles.map(({ node: article }) => (
          <HappeningThumbnail size="small" item={article} key={article.content.title.nb} />
        ))}
      </HorizontalScroll>
      <div style={{ marginTop: "1rem" }}>
        <Button href="/hva-skjer">
          {localize({ nb: "Vis flere", en: "More" })}
        </Button>
      </div>
    </div>
  );
};
